import { Link } from '@tanstack/react-router';
import type { StravaStatus } from '@painpal/contracts';
import { importCounts, importDaysLeft, importProgress } from '../../lib/strava';
import { importNote } from './fitnessStats';
import styles from './fitness.module.css';

export function StravaImportCard({ strava }: { strava: StravaStatus }) {
  if (strava.status === 'revoked') {
    return (
      <section className={styles.importCard} data-tone="revoked" aria-labelledby="import-title">
        <h2 id="import-title" className={styles.importTitle}>STRAVA DISCONNECTED</h2>
        <p className={styles.importNote}>Strava access was revoked. Rides already imported stay.</p>
        <Link to="/settings" className="btn btn-outline">RECONNECT IN SETTINGS →</Link>
      </section>
    );
  }
  const backfill = strava.backfill;
  if (backfill === null || backfill.status !== 'running') return null;
  const progress = importProgress(backfill);
  return (
    <section className={styles.importCard} aria-labelledby="import-title">
      <header className={styles.importHead}>
        <h2 id="import-title" className={styles.importTitle}>STRAVA HISTORY</h2>
        <span className={styles.importCount}>{importCounts(backfill)}</span>
      </header>
      <div
        className={styles.track} role="progressbar" aria-label="Strava import progress" aria-valuemin={0} aria-valuemax={100}
        aria-valuenow={progress === null ? undefined : Math.round(progress * 100)}
      >
        <span className={styles.trackFill} style={{ width: `${Math.round((progress ?? 0) * 100)}%` }} />
      </div>
      <p className={styles.importNote}>{importNote(importDaysLeft(backfill))}</p>
    </section>
  );
}
